var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.043,
    height: 86.826,
    viewBox: "0 0 74.043 86.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74.043,
    height: 86.826
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M37.341,13.266,66.477,81.625H45.121l12.235-8.13L37.341,26.532,13.86,81.625H8.206ZM37.341,0,.38,86.72l-.045.106H17.3l2.217-5.2,2.216-5.2,2.217-5.2L37.341,39.8,50.735,71.222h.046l-.036.025L28,86.826H74.347Z",
    transform: "translate(-0.304)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.667,125.224A31.777,31.777,0,0,1,29.789,78.013L32.224,72.3A36.978,36.978,0,0,0,7.232,130.938Z",
    transform: "translate(0 -65.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M455.622,78.23a31.613,31.613,0,0,1,10.431,4.576A31.88,31.88,0,0,1,477.57,96.789a31.718,31.718,0,0,1-1.9,28.49l2.442,5.73A36.978,36.978,0,0,0,453.181,72.5Z",
    transform: "translate(-411.322 -65.806)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.26ad8d87ce80002ec1caf4ba8d3d728d.svg";
export { ForwardRef as ReactComponent };